import { localeRequestHeaders } from './localePreference';
import { apiErrorMessage } from './apiErrorMessages';

const API_PREFIX = '/api/v1';

async function apiRequest(path, user, options = {}) {
  const token = await user.getIdToken();
  let response;

  try {
    response = await fetch(`${API_PREFIX}${path}`, {
      ...options,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
        ...localeRequestHeaders(),
        ...(options.headers || {}),
      },
    });
  } catch {
    throw new Error(apiErrorMessage('goalsNetwork'));
  }

  if (!response.ok) {
    const error = await response.json().catch(() => ({}));
    throw new Error(error.detail || apiErrorMessage('goalsRequest'));
  }

  return response.json();
}

export function refreshNetworkingRecommendations({ user }) {
  return apiRequest('/goals/networking/recommendations/refresh', user, {
    method: 'POST',
  });
}
